var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-control disabled"},[_c(_vm.getComponent,_vm._g(_vm._b({tag:"Component"},'Component',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }